export default {
    install(Vue) {
        Vue.filter('callDuration', function (value) {
            value = Math.round(value);
            let sec = value % 60;
            let min = parseInt(value / 60);
            if (sec < 10) {
                sec = `0${sec}`;
            }
            if (min < 10) {
                min = `0${min}`;
            }
            return `${min}:${sec}`;
        });
    }
}